module.exports = __webpack_public_path__ + "img/png.c0a26a17.png";